import EstimativeHelper from '@/helper/EstimativeHelper'

const moment = require('moment')
const fields = {
  affiliate_name: {
    sortable: false,
    text: 'Networks',
    align: 'center'
  },
  date: {
    sortable: true,
    text: 'Date',
    align: 'center',
  },
  dayweek: {
    sortable: true,
    text: 'Day week',
    align: 'center',
  },
  updatedAt: {
    sortable: true,
    text: 'Last update',
    align: 'center',
  },
  onHold: {
    sortable: true,
    text: 'Pending',
    align: 'center',
  },
  payout: {
    sortable: true,
    text: 'Approved',
    align: 'center',
  }
}

class ConsolidateAffiliate {
  static parseHeadersFrom (data) {
    let headers = []

    if (Array.isArray(data)) {
      let row = (data.length > 0) ? data[0] : []

      Object.entries(row).forEach(([key, value]) => {
        if (fields.hasOwnProperty(key)) {
          headers.push({
            sortable: fields[key]['sortable'],
            align: fields[key]['align'],
            text: fields[key]['text'],
            value: key
          })
        }
      })
    }

    return headers
  }
  static parseRowsFrom (data, currency = 'BRL') {
    let rows = []

    if (Array.isArray(data)) {
      data.map(item => {
        let row = {}

        // In order of columns.
        row.affiliate_name = (item.hasOwnProperty('affiliate_name')) ? item.affiliate_name : ''

        row.date = (item.hasOwnProperty('date')) ? moment(item.date, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
        row.dayweek = (item.hasOwnProperty('dayweek')) ? item.dayweek : ''

        if (item.hasOwnProperty('onHold')) {
          row.onHold = (item.onHold.hasOwnProperty(currency))
            ? item.onHold[currency]
            : 0.00
        }

        if (item.hasOwnProperty('payout')) {
          row.payout = (item.payout.hasOwnProperty(currency))
            ? item.payout[currency]
            : 0.00
        }

        row.updatedAt = (item.hasOwnProperty('updatedAt')) ? moment(item.updatedAt) : ''

        row.estimative = EstimativeHelper.salesEstimative(row)

        rows.push(row)
      })
    }

    return rows
  }
  static parseColumnFilters (data) {
    let filters = ''

    if (Array.isArray(data)) {
      filters = data.join(',')
    }

    return String(filters)
  }
  static parsePagination (data) {
    let pagination = {}

    if (data.hasOwnProperty('per_page')) {
      pagination['per_page'] = data.per_page
    }

    if (data.hasOwnProperty('page')) {
      pagination['page'] = data.page
    }

    if (data.hasOwnProperty('total_pages')) {
      pagination['total_pages'] = data.total_pages
    }

    if (data.hasOwnProperty('total_items')) {
      pagination['total_items'] = data.total_items
    }

    return pagination
  }
}

export default ConsolidateAffiliate
